import { TextField } from '@loadsmart/miranda-react'
import styled from 'styled-components'

export const StyledTextField = styled(TextField)`
    margin-bottom: 1em;
`